module.exports = __webpack_public_path__ + "static/media/horoscope-icon-5.6edb2042.png";


//////////////////
// WEBPACK FOOTER
// ./src/checkastronow/assets/images/horoscopes/horoscope-icon-5.png
// module id = 1531
// module chunks = 0